import { useRef } from 'react'
import { createUseStyles, useTheme } from 'react-jss'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import animations from './animations'
import style from './style'

const useStyles = createUseStyles(style)

const RevealImage = ({
  image,
  label,
}) => {
  const theme = useTheme()
  const classes = useStyles({ isIE11: theme.detect.isIE11 })
  const $imageContainer = useRef()
  const $image = useRef()

  const mediaQueryKey = useSelector((state) => state.mediaQuery.key)

  const showPhoto = () => {
    animations.show({
      $image: $image.current,
      $container: $imageContainer.current,
      delay: 0.2,
    })
  }

  const hidePhoto = () => {
    animations.hide({
      $image: $image.current,
      $container: $imageContainer.current,
    })
  }

  const handleMouseEnter = () => showPhoto()

  const handleMouseLeave = () => hidePhoto()

  return (
    <span className={classes.root}>
      <em
        className={classes.cta}
        onMouseEnter={mediaQueryKey > 1 ? handleMouseEnter : () => {}}
        onMouseLeave={mediaQueryKey > 1 ? handleMouseLeave : () => {}}
      >
        {label}
      </em>
      {mediaQueryKey > 1 && (
        <span
          ref={$imageContainer}
          className={classes.imageContainer}
        >
          <img
            ref={$image}
            className={classes.image}
            src={image}
            alt={label}
          />
        </span>
      )}
    </span>
  )
}

RevealImage.propTypes = {
  image: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
}

export default RevealImage
